<script lang="ts" setup>
import { onUnmounted } from 'vue'

const props = defineProps<{
  backdropClose?: boolean
  modelValue: boolean
  isScrollable?: boolean
}>()

const emit = defineEmits<{
  (event: 'update:modelValue', value: boolean): void
}>()

const close = () => {
  enableBodyScroll()
  emit('update:modelValue', false)
}

const closeBackdrop = () => (props.backdropClose ? close() : null)
const enableBodyScroll = () => {
  document.body.style.overflow = ''
}

onUnmounted(() => {
  enableBodyScroll()
})
</script>
<template>
  <teleport to="body">
    <div
      v-if="modelValue"
      class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[1000]"
      @click="closeBackdrop"
    >
      <div
        class="fixed max-w-[340px] md:max-w-[410px] bg-white rounded-2.5 shadow-custom-5 top-[140px] max-h-[80%] md:max-h-[90%] overflow-y-auto"
      >
        <div class="flex justify-between">
          <slot name="title"></slot>
          <button
            class="absolute top-2 right-2 text-gray-600 hover:text-gray-900 text-2xl"
            @click="close"
          >
            <svg
              class="block md:hidden"
              fill="none"
              height="28"
              stroke="black"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              viewBox="0 0 24 24"
              width="28"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M6 18L18 6M6 6l12 12" />
            </svg>
            <svg
              class="hidden md:block"
              fill="none"
              height="42"
              stroke="black"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              viewBox="0 0 24 24"
              width="42"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <div class="">
          <slot></slot>
        </div>

        <div class="base-modal__actions">
          <slot name="actions"></slot>
        </div>
      </div>
    </div>
  </teleport>
</template>
<style lang="sass" scoped>
.base-modal
  &__actions
    @apply flex justify-between
</style>
